import axios from "axios";

const baseUrl = "api/v1/table_configurations";

const fetch = tableKey => axios.get(`${baseUrl}/${tableKey}`);

const create = payload => axios.post(baseUrl, { tableConfiguration: payload });

const update = ({ tableKey, payload }) =>
  axios.patch(`${baseUrl}/${tableKey}`, { tableConfiguration: payload });

const destroy = tableKey => axios.delete(`${baseUrl}/${tableKey}`);

const tableConfigurationApi = { fetch, create, update, destroy };

export default tableConfigurationApi;
